var circlesElement = document.querySelector('.circles');

if (circlesElement) {
    var contentBlockHeight = circlesElement.offsetHeight;
	contentBlockHeight = contentBlockHeight - 220;
	var style = document.querySelector('.circles').style;
    var colours = ['#0FA958', '#F24D1D', '#FFC600'];

	// Generate a random number between 0 and contentBlockHeight
	var randomTopBefore = Math.floor(Math.random() * contentBlockHeight);
	var randomTopAfter = Math.floor(Math.random() * contentBlockHeight);

    // if randomTopBefore is less than 200, add 200 to randomTopBefore
    if (randomTopBefore < 200) {
        randomTopBefore = randomTopBefore + 240;
    }

    if (randomTopAfter < 200) {
        randomTopAfter = randomTopAfter + 240;
    }

    // Set variables
	style.setProperty('--random-top-before', randomTopBefore + 'px');
	style.setProperty('--random-top-after', randomTopAfter + 'px');

    // Assign random colour
    var randomColourBefore = colours[Math.floor(Math.random() * colours.length)];

    // Remove randomColourBefore from colours array
    colours = colours.filter(function(item) {
        return item !== randomColourBefore;
    });

    var randomColourAfter = colours[Math.floor(Math.random() * colours.length)];

    style.setProperty('--random-colour-before', randomColourBefore);
    style.setProperty('--random-colour-after', randomColourAfter);

    // console.log('randomTopBefore: ', randomTopBefore);
    // console.log('randomTopAfter: ', randomTopAfter);
}
